import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./SurveyView.module.css";
import { markStarted } from "../../utils/SurveyAnswers";
import { getSurvey } from "../../utils/APIConnector";
import { ensureLoginWithRid } from "../../utils/APIConnector/APIConnector";
import { checkTicketNumber } from "../../utils/APIConnector/APIConnector";
import { getRefreshToken } from "../../session/TokenStore";
import PageLayout from "../PageLayout";

export default function SurveyView() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [survey, setSurvey] = useState(null);
    const [error, setError] = useState(false);
    const { t, i18n } = useTranslation();
    const [ticketNumber, setTicketNumber] = useState("");
    const [ridCode, setRidCode] = useState("");

    useEffect(() => {
        getSurvey(id)
            .then((data) => setSurvey(data))
            .catch(() => setError(true));
    }, [id]);

    const onClickSurvey = async () => {
        const restriction = survey?.restrictions;
        if (restriction === "login" && !getRefreshToken()) {
            alert(t("survey.restrictionInfo"));
            navigate("/login", { replace: true });
            return;
        }
        if (restriction === "ticket") {
            if (ticketNumber.trim() === "") {
                alert(t("survey.ticketNumberRequired"));
                return;
            }
            const ticketNumberValid = await checkTicketNumber(ticketNumber);
            if (!ticketNumberValid) {
                alert(t("survey.ticketNumberInvalid") + ` ${ticketNumber}`);
                return;
            }
        }
        markStarted(id);
        if (ridCode) {
            const rid = ridCode.trim();
            try { sessionStorage.setItem(`survey:${id}:rid`, rid); } catch { }
            try { await ensureLoginWithRid(rid); } catch { }
            navigate(`/surveys/${id}/page/1`, { replace: true });
            return;
        }



        navigate(`/surveys/${id}/page/1`, { replace: true });
    };

    if (error) return <p>{t("survey.loadError")}</p>;
    if (!survey) return <p>{t("survey.loading")}</p>;

    const pickText = (obj) => {
        const lang = i18n.language;
        const byLang = obj?.[lang];
        if (typeof byLang === "string" && byLang.trim() !== "") return byLang;
        const byEn = obj?.en;
        if (typeof byEn === "string" && byEn.trim() !== "") return byEn;
        const byPl = obj?.pl;
        if (typeof byPl === "string" && byPl.trim() !== "") return byPl;
        return "";
    };

    return (
        <PageLayout>
            <div className={styles.section}>
                <h1 className={styles.title}>
                    {pickText(survey?.title)}
                </h1>
                <p className={styles.description}>
                    {pickText(survey?.description)}
                </p>
                <ul className={styles.meta}>
                    <li>{t("surveys.meta.time")}: {`~${survey.estimatedTime}min`}</li>
                </ul>
                {survey.restrictions === "ticket" && (
                    <div className={styles.ticketField}>
                        <label htmlFor="ticketNumber">{t("survey.ticket")}</label>
                        <input type="text" id="ticketNumber" name="ticketNumber" value={ticketNumber} onChange={(e) => setTicketNumber(e.target.value)} />
                    </div>
                )}
            </div>
            <div className={styles.section}>
                <h2 className={styles.subtitle}>{t("survey.ridTitle")}</h2>
                <p className={styles.description}>{t("survey.ridInfo")}</p>
                <p className={styles.description}>{t("survey.ridInfo2")}</p>
                <div className={styles.ridField}>
                    <label htmlFor="ridCode">{t("survey.ridLabel")}</label>
                    <input
                        type="text"
                        id="ridCode"
                        name="ridCode"
                        placeholder={t("survey.ridPlaceholder")}
                        value={ridCode}
                        onChange={(e) => setRidCode(e.target.value)}
                    />
                </div>

            </div>
            <button
                className={styles.startBtn}
                onClick={onClickSurvey}
            >
                {t("survey.startButton")}
            </button>
        </PageLayout>
    );
}
